/**
 * TextMCQEmptyValidator class is responsible for validating whether a text-based multiple-choice question (MCQ) model is empty.
 * It uses Angular's $translate service for localization and provides detailed validation results.
 */
class TextMCQEmptyValidator {
    /**
     * Constructs a new TextMCQEmptyValidator instance.
     * @param {Object} model - The model to be validated.
     * @param {Object} $injector - Angular's injector service for retrieving dependencies.
     */
    constructor(model, $injector) {
        this.model = model;
        this.$injector = $injector;
        this._translate = null;
        this._messageTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.EMPTY.TEXT-MCQ';
        this._message = null;
        this._forced_check = false;
    }

    /**
     * Lazily initializes and returns the $translate service.
     * @returns {Object} The $translate service.
     */
    get $translate() {
        if (!this._translate) {
            this._translate = this.$injector.get('$translate');
        }
        return this._translate;
    }

    /**
     * Validates the model and returns the validation result.
     * @param {string} from - The source from which the validation is triggered.
     * @returns {Object} The validation result.
     */
    validate(from) {
        let error = this.model.isContentEmpty();

        // If there's an error but no parents, clear the error.
        if (error && this.model.getParents().length === 0) {
            error = false;
        }

        return {
            'onSheetBlur':      false,
            'onlyBanner':       false,
            'validator':        this.getValidatorName(),
            'modelUUID':        this.model.getUUID(),
            'error':            error,
            'status':           error ? 'DANGER' : 'SUCCESS',
            'message':          this.getErrorMessage(),
            'message_template': false,
            'callbacks':        [
                'validationDisplayObjectHeader-' + this.model.getUUID()
            ]
        };
    }

    /**
     * Returns the error message for the validation.
     * @returns {string} The error message.
     */
    getErrorMessage() {
        let questionHeadline = this.model.getQuestionHeadline();
        this._message = this.$translate.instant(this._messageTranslateString, {
            s: questionHeadline ? questionHeadline : ''
        });

        return this._message;
    }

    /**
     * Returns the forced check status.
     * @returns {boolean} The forced check status.
     */
    forcedCheck() {
        return this._forced_check;
    }

    /**
     * Returns the name of the validator.
     * @returns {string} The validator name.
     */
    getValidatorName() {
        return 'TextMCQEmptyValidator';
    }
}

export default TextMCQEmptyValidator;